import React, { useState } from "react";
import { useHistory } from "react-router-dom";

const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();

  const handleSubmit = async (event) => {
    event.preventDefault();

    let headersList = {
      Accept: "*/*",
      "User-Agent": "Thunder Client (https://www.thunderclient.com)",
      "Content-Type": "application/json",
    };

    let bodyContent = JSON.stringify({
      password: password,
      email: email,
      type: "tenant_type",
    });
    console.log("watereawr bodyContent", bodyContent);
    try {
      let response = await fetch(`https://auth2.${backend_api_base_url}/login`, {
        method: "POST",
        body: bodyContent,
        headers: headersList,
      });

      if (response.ok) {
        let data = await response.json();
        console.log(data.statusCode, "what is there", data, typeof data);

        if (Number(data.statusCode) == 200) {
          const p_data = JSON.parse(data.body);
          console.log("data.token data.token", p_data);

          if (p_data.token) {
            localStorage.setItem("token", p_data.token);
            history.push("/all_chats");
          } else {
            console.error("No token");
          }
        } else {
          // let data = await response.text();
          console.error(
            "Login failed: with statusCode",
            Number(data.statusCode)
          );
        }
      } else {
        let data = await response.text();
        console.error("Login failed:", data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div>
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Tenant: Email</label>
          <input
            type="tenant"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Login</button>
      </form>
    </div>
  );
}
